import React, { useState, useEffect, useRef } from "react";
import { ZoomIn } from "lucide-react";

import HeroCTR from "../../components/hero/HeroSectionComp"; 

function GalleryCTR() {
  const [selectedImage, setSelectedImage] = useState(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (selectedImage) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";

      const preventTouch = (e) => {
        if (!modalRef.current) return;
        const isInsideModal = modalRef.current.contains(e.target);
        if (!isInsideModal) {
          e.preventDefault();
        }
      };
      document.addEventListener("touchmove", preventTouch, { passive: false });

      return () => {
        const top = parseInt(document.body.style.top || "0", 10);
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, -top);
        document.removeEventListener("touchmove", preventTouch);
      };
    }
  }, [selectedImage]);

  const images = [
    // "/images/gallery/gallery6.jpg",
    // "/images/gallery/gallery3.jpg",
    // "/images/gallery/gallery5.jpg",
    // "/images/gallery/gallery2.jpg",
    // "/images/gallery/gallery4.jpg",
    // "/images/gallery/gallery1.jpg",
    "/images/gallery/g1.jpeg",
    "/images/gallery/g2.jpeg",
    "/images/gallery/g3.jpeg",
    "/images/gallery/g4.jpeg",
    "/images/gallery/g5.jpeg",
    "/images/gallery/g6.jpeg",
    "/images/gallery/g7.jpeg",
    "/images/gallery/g8.jpeg",
    "/images/gallery/g9.jpeg",
    "/images/gallery/g10.jpeg",
    "/images/gallery/g11.jpeg",
    "/images/gallery/g12.jpeg",
    "/images/gallery/g13.jpeg",
    "/images/gallery/g14.jpeg",
    "/images/gallery/g15.jpeg",
    "/images/gallery/g16.jpeg",
    "/images/gallery/g17.jpeg",
    "/images/gallery/g18.jpeg",
    "/images/gallery/g19.jpeg",
    "/images/gallery/g20.jpeg",
    "/images/gallery/g21.jpeg",
    "/images/gallery/g22.jpeg",
    "/images/gallery/g23.jpeg",
    "/images/gallery/g24.jpeg",
    "/images/gallery/g25.jpeg",
    "/images/gallery/g26.jpeg",
    "/images/gallery/g27.jpeg",
    "/images/gallery/g28.jpeg",
    "/images/gallery/g30.jpeg",
    "/images/gallery/g31.jpeg",
    "/images/gallery/g32.jpeg",
  ];

  return (
    <div>
      <HeroCTR
        img="/images/hero/bg-subheader.jpg"
        heading="Gallery"
        para="Moments Worth Capturing"
      />

      <div className="flex mt-12 md:mt-22">
        <h3 className="text-[18px] border-1 border-[#606060] hover:border-[#FC9F1C] font-medium text-[#606060] px-3 py-1 rounded-[4px] transition-all duration-300">
          UAE
        </h3>
      </div>

      <div className="w-full mt-8">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-2">
          {images.map((src, index) => (
            <div
              key={index}
              className="mb-2 break-inside-avoid overflow-hidden rounded-[4px] relative group cursor-pointer"
            >
              <img
                src={src}
                alt={`gallery${index}`}
                className="w-full rounded-[4px] transition-transform duration-700 ease-in-out group-hover:scale-110 object-cover"
              />

              <div className="absolute inset-0 bg-black/60 flex items-center justify-center translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
                <button
                  onClick={() => setSelectedImage(src)}
                  className="p-3 bg-white/20 rounded-full hover:bg-white/40 transition"
                >
                  <ZoomIn className="text-white w-6 h-6" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div
          ref={modalRef}
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-5 text-white bg-[#FC9F1C] hover:bg-[#E08B17] w-[30px] h-[30px] flex justify-center items-center rounded-full z-50"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
          >
            ✕
          </button>

          <div
            className="relative max-w-4xl w-full px-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="bg-contain bg-no-repeat bg-center w-full md:w-[832px] h-[600px] rounded-[4px] shadow-lg"
              style={{ backgroundImage: `url(${selectedImage})` }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default GalleryCTR;
